import { apiFetch } from '@/lib/api'
import type { SystemService } from '@/services/contracts'
import type { AdminOverview, SystemSourcesResponse } from '@/types/models'

export const httpSystemService: SystemService = {
  async sources() {
    return apiFetch<SystemSourcesResponse>('/system/sources')
  },

  async adminOverview() {
    return apiFetch<AdminOverview>('/system/admin-overview')
  },
}
